import { FC, SVGAttributes } from 'react';

const NavLeft: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Icons/Chevron Arrow Left 24x24">
                <g id="Arrow - Left 2">
                    <path
                        id="Stroke 1"
                        d="M15 18L9 12L15 6"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
        </svg>
    );
};

export default NavLeft;
